import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoFreeTradeZoneAgreements extends Component {

    render() {
        const { freeTradeZoneAgreements } = this.props;
        const summary = getTitleSummary(freeTradeZoneAgreements)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Импортная пошлина. Соглашения о зоне свободной торговли'],
                    rows: summary
                }}
                expanded={(freeTradeZoneAgreements.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Страна происхождения',
                        'Cтрана таможенной очистки',
                        'Ставка',
                        'Нормативный документ',
                        'Комментарий'
                    ],
                    rows: freeTradeZoneAgreements.map((
                        {
                            to_date = null,
                            joined_origin_country = '',
                            customs_clearance_country = '',
                            hint = '',
                            order,
                            order_date,
                            orders_info = null,
                            description = ''
                        }) => ([
                            <ToDateNotificator to_date={to_date} />,
                            joined_origin_country,
                            customs_clearance_country,
                            hint,
                            formatOrder(order, order_date, orders_info),
                            description
                        ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    var hint = items.length !== 0 ? items[0].hint : 'нет' ;
    items.every(function (item, i) {
        if (item.hint !== hint) {
            hint += ' (базовая ставка)';
            return false;
        } else {
            return true;
        }
    });
    return [[hint]];
}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoFreeTradeZoneAgreements.js